import {
  Avatar,
  Badge,
  Button,
  Checkbox,
  Chip,
  Collapse,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  Menu,
  OutlinedInput,
  Paper,
  Switch,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';
import {
  Theme,
  createStyles,
  fade,
  makeStyles
} from '@material-ui/core/styles';
import {
  AddRounded,
  ClearRounded,
  CloudUploadRounded,
  EditRounded,
  FaceRounded,
  FileCopyOutlined,
  KeyboardArrowRightRounded,
  LaunchRounded,
  LinkRounded,
  LocalShippingRounded,
  MoreVertRounded,
  SyncRounded,
  UpdateRounded
} from '@material-ui/icons';
import { Alert, Autocomplete } from '@material-ui/lab';
import { KeyboardDatePicker } from '../../components/CustomDatePicker';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import clsx from 'clsx';
import { FileWithPath } from 'file-selector';
import moment from 'moment';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router';
import { Link as RRLink } from 'react-router-dom';
import {
  CreateProjectDocumentWorkflowWithChecklist,
  CreateWorkflowStep
} from '../../api/project-document-workflows';
import { RootState } from '../../app/store';
import DocRevisionInfoCard from '../../components/DocRevisionInfoCard';
import DropzoneArea from '../../components/DropzoneArea';
import HelpTooltip from '../../components/HelpTooltip';
import ProjectInfoCard from '../../components/ProjectInfoCard';
import { SHOW_LINK_DUE_DATE, WORKFLOW_LINK_DUE_DATE } from '../../constants';
import { addMomentWeekdays } from '../../functions/addWeekdays';
import checkWebUrl from '../../functions/checkWebUrl';
import getIconFile from '../../functions/getIconFile';
import handleDropRejected from '../../functions/handleDropRejected';
import mapExistingUserInWorkflowStep from '../../functions/mapExistingUserInWorkflowStep';
import selectOnlyOneUser from '../../functions/selectOnlyOneUser';
import { useAppDispatch } from '../../hooks/useAppRudux';
import useDropzoneArea from '../../hooks/useDropzoneArea';
import { useQueryStringNumber } from '../../hooks/useQueryString';
import AutoAwesomeRounded from '../../icon/AutoAwesomeRounded';
import BotIcon from '../../icon/BotIcon';
import Breadcrumb from '../Breadcrumb';
import loadingSlice from '../Loading/loadingSlice';
import { Discipline } from '../MasterData/Discipline/disciplineSlice';
import { getDocumentWithProjectUsersAsync } from '../MasterData/Document/documentSlice';
import { getWorkflowStepWithPositionsAsync } from '../MasterData/StandardWorkflow/standardWorkflowSlice';
import { getProjectUsersAsync } from '../Project/projectUsersSlice';
import { getProjectApprovalPeriodsAsync } from '../ProjectApprovalPeriod/projectApprovalPeriodSlice';
import { PurposeLabel } from '../ProjectDocument/BulkPlanning';
import { WorkflowStatusLabel } from '../ProjectDocumentRevision/DocumentRevisionView';
import { getProjectDocumentRevisionAsync } from '../ProjectDocumentRevision/projectDocumentRevisionSlice';
import {
  ProjectWorkflow,
  getProjectWorkflowsAsync
} from '../ProjectWorkflow/projectWorkflowSlice';
import { User } from '../UserProfile/userProfileSlice';
import { reloadUserProjectPositionsAsync } from '../UserProjectPosition/userProjectPositionSlice';
import {
  createProjectDocumentWorkflowAsync,
  getProjectDocumentWorkflowAsync
} from './projectDocumentWorkflowSlice';

interface WorkflowStepUsers {
  workflowStepId: number;
  userIds: number[];
}

interface TemplateFlow {
  discipline: Discipline | null;
  projectFlow: ProjectWorkflow | null;
}

interface DocumentWorkflow {
  name: string | null;
  linkName: string | null;
  linkUrl: string | null;
  isAutoApproval: boolean;
  isCreatorViewOnlyExternal: boolean;
  isCreatorViewOnlyFinal: boolean;
  projectDocumentWorkflowSteps: CreateWorkflowStep[];
  isChecked: boolean;
  checklistLinkUrl: string | null;
  files: FileWithPath[];
}

let inputKey = 0;

export default function DocumentWorkflowCreate() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const dropzoneArea = useRef<HTMLDivElement | null>(null);
  const { inDropzone } = useDropzoneArea(dropzoneArea);

  const documentRevisionId = useQueryStringNumber({
    query: 'documentRevisionId'
  });
  const refFlowId = useQueryStringNumber({ query: 'refFlowId' });

  const { data: disciplines } = useSelector(
    (state: RootState) => state.disciplines
  );
  const { data: workflowSteps } = useSelector(
    (state: RootState) => state.workflowSteps
  );

  const { data: users, loading: usersLoading } = useSelector(
    (state: RootState) => state.projectUsers
  );

  const { data: projectWorkflows } = useSelector(
    (state: RootState) => state.projectWorkflows
  );
  const { data: projectApprovalPeriods } = useSelector(
    (state: RootState) => state.projectApprovalPeriods
  );
  const { selectedProjectDocumentWorkflow } = useSelector(
    (state: RootState) => state.projectDocumentWorkflows
  );
  const { selectedProjectDocumentRevision } = useSelector(
    (state: RootState) => state.projectDocumentRevisions
  );
  const { selectedProjectDocument } = useSelector(
    (state: RootState) => state.projectDocuments
  );
  const { documentWithProjectUsers } = useSelector(
    (state: RootState) => state.documents
  );
  const { selectedProject } = useSelector((state: RootState) => state.projects);
  const { headers } = useSelector(
    (state: RootState) => state.standardWorkflows
  );

  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);
  const [templateFlows, setTemplateFlows] = useState<TemplateFlow>({
    discipline: null,
    projectFlow: null
  });
  // Collect information to dynamic user option in each step
  const [workflowStepUsers, setWorkflowStepUsers] = useState<
    WorkflowStepUsers[]
  >([]);
  const [isShowAllUsers, setIsShowAllUsers] = useState<boolean>(false);
  const [isStandardWorkflow, setIsStandardWorkflow] = useState<boolean>(false);
  const [isPreviewWorkflow, setIsPreviewWorkflow] = useState<boolean>(false);

  const [openWorkflowDialog, setOpenWorkflowDialog] = useState<boolean>(false);
  const [viewSkipStandardWorkflow, setViewSkipStandardWorkflow] =
    useState<boolean>(false);
  const [isSkipStandardWorkflow, setIsSkipStandardWorkflow] =
    useState<boolean>(false);

  const MAX_SIZE_IN_MB = Number.parseInt(
    process.env.REACT_APP_COMMON_FILE_SIZE || '25',
    10
  );
  const { getRootProps, getInputProps } = useDropzone({
    onDropAccepted,
    onDropRejected: (fileRejections) =>
      handleDropRejected(fileRejections, dispatch, MAX_SIZE_IN_MB),
    onDrop: () => inputKey++, // To reset input every time any action occurs
    // To select type of upload file add 'accept' property e.g. accept: '.pdf'
    maxSize: MAX_SIZE_IN_MB * 1048576, //maxSize per file is 25 MB
    multiple: true
  });

  // Set today as start date
  let documentDueDate = moment().endOf('day');
  // Create default workflowStep for reuse
  let defaultWorkflowSteps = workflowSteps.map((workflowStep) => {
    //  Find approvalPeriod of this workflowStep
    const projectApprovalPeriod = projectApprovalPeriods.find(
      (approvalPeriod) => workflowStep.id === approvalPeriod.workflowStepId
    );
    // Add date if find approvalPeriod
    documentDueDate = projectApprovalPeriod
      ? addMomentWeekdays(documentDueDate, projectApprovalPeriod.value)
      : documentDueDate;
    //Set object for adding in state
    return {
      ...workflowStep,
      isRequired: true,
      dueDate: moment(documentDueDate).endOf('day').toDate(),
      users: [] as User[]
    };
  });

  const [documentWorkflow, setDocumentWorkflow] = useState<DocumentWorkflow>({
    name: '',
    linkName: null,
    linkUrl: null,
    isAutoApproval: false,
    isCreatorViewOnlyExternal: false,
    isCreatorViewOnlyFinal: false,
    projectDocumentWorkflowSteps: defaultWorkflowSteps,
    isChecked: false,
    checklistLinkUrl: null,
    files: []
  });
  const notFoundUserPosition =
    documentWorkflow.projectDocumentWorkflowSteps.filter(
      (projectDocumentWorkflowStep) =>
        projectDocumentWorkflowStep.isRequired &&
        projectDocumentWorkflowStep.users.length > 0
    ).length === 0;
  const moreThanOneUserInWorkflowStep =
    documentWorkflow.projectDocumentWorkflowSteps
      .filter(({ isRequired }) => isRequired)
      .some(
        (projectDocumentWorkflowStep) =>
          selectOnlyOneUser(projectDocumentWorkflowStep.id) &&
          projectDocumentWorkflowStep.users.length > 1
      );
  const [tempWorkflowStep, setTempWorkflowStep] = useState<
    CreateWorkflowStep[]
  >([]);
  const [showDueDateWarning, setShowDueDateWarning] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const isStandardWorkflowDocument = Boolean(
    documentWithProjectUsers &&
    documentWithProjectUsers.projectPositionWorkflowSteps.length > 0
  );
  const isCompletedWorkflow =
    selectedProjectDocumentRevision?.projectDocumentWorkflows[0]
      ?.workflowStatusId === WorkflowStatusLabel.Completed;

  useEffect(() => {
    if (selectedProjectDocumentWorkflow && refFlowId) {
      // For adding information from reference project document workflow
      // and calculate default approval period in each step
      let documentDueDate = moment().endOf('day');
      defaultWorkflowSteps = workflowSteps.map((workflowStep) => {
        //  Find approvalPeriod of this workflowStep
        const projectApprovalPeriod = projectApprovalPeriods.find(
          (approvalPeriod) => workflowStep.id === approvalPeriod.workflowStepId
        );
        // This workflow step has been selected for answer
        const thisPreviousWorkflow =
          selectedProjectDocumentWorkflow.projectDocumentWorkflowSteps.find(
            (projectDocumentWorkflowStep) =>
              projectDocumentWorkflowStep.workflowStepId === workflowStep.id
          );
        // Add date if find approvalPeriod and be selected for answer
        documentDueDate =
          projectApprovalPeriod && thisPreviousWorkflow
            ? addMomentWeekdays(documentDueDate, projectApprovalPeriod.value)
            : documentDueDate;
        // Find each user in this step
        let usersInThisStep: User[] = [];
        if (thisPreviousWorkflow) {
          usersInThisStep = thisPreviousWorkflow.userApprovals.map(
            (userApproval) => {
              return users.find(
                (user) => user.id === userApproval.userId
              ) as User;
            }
          );
        }
        //Set object for adding in state
        return {
          ...workflowStep,
          isRequired: Boolean(thisPreviousWorkflow),
          dueDate: moment(documentDueDate).endOf('day').toDate(),
          users: usersInThisStep
        };
      });
      setDocumentWorkflow({
        ...documentWorkflow,
        name: refFlowId ? selectedProjectDocumentWorkflow.name : null,
        isAutoApproval: refFlowId
          ? Boolean(selectedProjectDocumentWorkflow.isAutoApproval)
          : false,
        isCreatorViewOnlyExternal: refFlowId
          ? Boolean(selectedProjectDocumentWorkflow.isCreatorViewOnlyExternal)
          : false,
        isCreatorViewOnlyFinal: refFlowId
          ? Boolean(selectedProjectDocumentWorkflow.isCreatorViewOnlyFinal)
          : false,
        projectDocumentWorkflowSteps: defaultWorkflowSteps
      });
      setWorkflowStepUsers([]);
      setIsShowAllUsers(true);
      setIsStandardWorkflow(false);
      setIsPreviewWorkflow(false);
    } else if (
      documentWithProjectUsers &&
      documentWithProjectUsers.projectPositionWorkflowSteps.length > 0 &&
      !isSkipStandardWorkflow
    ) {
      // For standard workflow which not has reference project document workflow
      const projectPositionWorkflowSteps =
        documentWithProjectUsers.projectPositionWorkflowSteps;

      let documentDueDate = moment().endOf('day');
      const workflowStepUsers: WorkflowStepUsers[] = [];
      defaultWorkflowSteps = workflowSteps.map((workflowStep) => {
        //  Find approvalPeriod of this workflow step
        const projectApprovalPeriod = projectApprovalPeriods.find(
          (approvalPeriod) => workflowStep.id === approvalPeriod.workflowStepId
        );
        // Find all project positions in this workflow step
        const projectPositions = projectPositionWorkflowSteps
          .filter(
            (projectPositionWorkflowStep) =>
              projectPositionWorkflowStep.workflowStepId === workflowStep.id
          )
          .map(
            (projectPositionWorkflowStep) =>
              projectPositionWorkflowStep.projectPosition
          );

        // Find users in this step
        let usersInThisStep: User[] = [];
        if (projectPositions.length > 0) {
          const userIds: number[] = [];
          projectPositions.forEach((projectPosition) => {
            if (projectPosition) {
              userIds.push(
                ...projectPosition.userProjectPositions.map(
                  (userProjectPosition) => userProjectPosition.userId
                )
              );
            }
          });
          if (userIds.length > 0) {
            // Filter array to have unique values
            const uniqueUserIds = userIds.filter((item, pos) => {
              return userIds.indexOf(item) == pos;
            });
            // Find user from userId and add in this step
            uniqueUserIds.forEach((userId) => {
              const user = users.find((user) => user.id === userId);
              if (user) usersInThisStep.push(user);
            });
            // Collect userId in this step
            workflowStepUsers.push({
              workflowStepId: workflowStep.id,
              userIds: uniqueUserIds
            });
          }
        }
        // Add date if find `projectApprovalPeriod` and `usersInThisStep` in this step
        documentDueDate =
          projectApprovalPeriod &&
            projectPositions.length > 0 &&
            usersInThisStep.length > 0
            ? addMomentWeekdays(documentDueDate, projectApprovalPeriod.value)
            : documentDueDate;

        //Set object for adding in state
        return {
          ...workflowStep,
          isRequired: Boolean(usersInThisStep.length > 0),
          dueDate: moment(documentDueDate).endOf('day').toDate(),
          users: usersInThisStep
        };
      });

      setDocumentWorkflow({
        ...documentWorkflow,
        name: t('projectDocumentWorkflowCreate.labels.standardWorkflow') as string,
        isAutoApproval: Boolean(
          selectedProjectDocumentRevision?.isAutoApproval
        ),
        projectDocumentWorkflowSteps: defaultWorkflowSteps
      });
      setWorkflowStepUsers(workflowStepUsers);
      setIsShowAllUsers(false);
      setIsStandardWorkflow(true);
      setIsPreviewWorkflow(true);
    } else {
      setDocumentWorkflow({
        ...documentWorkflow,
        name: '',
        isAutoApproval: Boolean(
          selectedProjectDocumentRevision?.isAutoApproval
        ),
        projectDocumentWorkflowSteps: defaultWorkflowSteps
      });
      setWorkflowStepUsers([]);
      setIsShowAllUsers(true);
      setIsStandardWorkflow(false);
      setIsPreviewWorkflow(false);
    }
  }, [
    workflowSteps,
    projectApprovalPeriods,
    selectedProjectDocumentWorkflow,
    documentWithProjectUsers,
    users,
    isSkipStandardWorkflow
  ]);

  useEffect(() => {
    if (selectedProject) {
      dispatch(getProjectWorkflowsAsync({ projectId: selectedProject.id }));
      dispatch(getProjectApprovalPeriodsAsync(selectedProject.id));
    }
    if (!refFlowId && selectedProject && selectedProjectDocument) {
      dispatch(
        getDocumentWithProjectUsersAsync({
          id: selectedProjectDocument.documentId,
          projectId: selectedProject.id
        })
      );
    }
  }, [selectedProject, selectedProjectDocument]);

  useEffect(() => {
    if (documentRevisionId) {
      dispatch(getProjectDocumentRevisionAsync(documentRevisionId));
    }
    if (refFlowId) {
      dispatch(getProjectDocumentWorkflowAsync(refFlowId));
    }
    if (headers.length === 0) {
      dispatch(getWorkflowStepWithPositionsAsync());
    }
  }, []);

  // Get users in project
  useEffect(() => {
    if (selectedProject?.id) {
      dispatch(getProjectUsersAsync(selectedProject.id));
    }
  }, [selectedProject?.id, dispatch]);

  function fileList(files: FileWithPath[]): ReactNode {
    return files.map((file, index) => {
      const fileSizeInKB = Math.round(file.size / 1024);
      const fileSizeInMB = Math.round((file.size * 10) / 1048576) / 10;
      const fileSize =
        file.size > 1048576 ? `${fileSizeInMB}MB` : `${fileSizeInKB}KB`;
      return (
        <div className={classes.flexAlignCenter} key={index}>
          {getIconFile(file.path as string)}
          <Typography
            className={clsx(classes.filename, classes.marginLR)}
            variant="body2"
          >
            {`${file.path} (${fileSize})`}
          </Typography>
          <Tooltip title={t('projectDocumentWorkflowCreate.tooltips.remove') as string} arrow>
            <IconButton
              size="small"
              onClick={() => onFilterOut(file.path as string)}
            >
              <ClearRounded />
            </IconButton>
          </Tooltip>
        </div>
      );
    });
  }

  function onDropAccepted(acceptedFiles: FileWithPath[]) {
    const previousFiles = documentWorkflow.files.filter(
      (file) =>
        !acceptedFiles.some((acceptedFile) => acceptedFile.path === file.path)
    );
    setDocumentWorkflow({
      ...documentWorkflow,
      files: [...previousFiles, ...acceptedFiles]
    });
  }

  function onFilterOut(path: string) {
    const newFiles = documentWorkflow.files.filter(
      (file) => file.path !== path
    );
    setDocumentWorkflow({
      ...documentWorkflow,
      files: newFiles
    });
  }

  function onChangeByField(
    projectWorkflowStepId: number,
    value: boolean | MaterialUiPickersDate | User[],
    fieldName: string,
    options?: { selectOneUser: boolean }
  ) {
    let newValue = value;
    const { projectDocumentWorkflowSteps } = documentWorkflow;
    const documentWorkflowStepIndex = projectDocumentWorkflowSteps.findIndex(
      (projectWorkflowStep) => projectWorkflowStep.id === projectWorkflowStepId
    );
    // For select ONLY one user
    if (options?.selectOneUser && value) {
      const newUsers = value as User[];
      const currentUsers =
        projectDocumentWorkflowSteps[documentWorkflowStepIndex].users;
      const isReplaceUser = currentUsers.length < newUsers.length;
      if (isReplaceUser) {
        newValue = newUsers.filter((newUser) =>
          currentUsers.every((currentUser) => currentUser.id !== newUser.id)
        );
      } else {
        newValue = newUsers;
      }
    }
    const newProjectWorkflowStep = {
      ...projectDocumentWorkflowSteps[documentWorkflowStepIndex],
      [fieldName]: newValue
    };
    const newProjectWorkflowSteps = [
      ...projectDocumentWorkflowSteps.slice(0, documentWorkflowStepIndex),
      newProjectWorkflowStep,
      ...projectDocumentWorkflowSteps.slice(documentWorkflowStepIndex + 1)
    ];
    setDocumentWorkflow({
      ...documentWorkflow,
      projectDocumentWorkflowSteps: newProjectWorkflowSteps
    });
  }

  function onResetAllSteps(): void {
    setDocumentWorkflow({
      ...documentWorkflow,
      projectDocumentWorkflowSteps: defaultWorkflowSteps
    });
    setShowDueDateWarning(false);
  }

  function onReCalculateDueDate(): void {
    let documentDueDate = moment().endOf('day');
    const projectDocumentWorkflowSteps =
      documentWorkflow.projectDocumentWorkflowSteps.map(
        (projectDocumentWorkflowStep) => {
          const projectApprovalPeriod = projectApprovalPeriods.find(
            (approvalPeriod) =>
              projectDocumentWorkflowStep.id === approvalPeriod.workflowStepId
          );
          documentDueDate =
            projectApprovalPeriod && projectDocumentWorkflowStep.isRequired
              ? addMomentWeekdays(documentDueDate, projectApprovalPeriod.value)
              : documentDueDate;
          return {
            ...projectDocumentWorkflowStep,
            dueDate: moment(documentDueDate).endOf('day').toDate()
          };
        }
      );
    setDocumentWorkflow({
      ...documentWorkflow,
      projectDocumentWorkflowSteps
    });
    dispatch(
      loadingSlice.actions.success({
        message: t('projectDocumentWorkflowCreate.messages.dueDateUpdated') as string
      })
    );
    scrollTo('reviewer-box');
    setShowDueDateWarning(false);
  }

  function onChangeWorkflowTemplate(
    event: any,
    newValue: ProjectWorkflow | null
  ) {
    setTemplateFlows({
      ...templateFlows,
      projectFlow: newValue
    });
    if (newValue) {
      let documentDueDate = moment().endOf('day');
      const projectDocumentWorkflowSteps = workflowSteps.map((workflowStep) => {
        const documentWorkflowStep = newValue.projectWorkflowSteps.find(
          (projectWorkflowStep) =>
            workflowStep.id === projectWorkflowStep.workflowStepId
        );
        const projectApprovalPeriod = projectApprovalPeriods.find(
          (approvalPeriod) => workflowStep.id === approvalPeriod.workflowStepId
        );
        documentDueDate =
          documentWorkflowStep && projectApprovalPeriod
            ? addMomentWeekdays(documentDueDate, projectApprovalPeriod.value)
            : documentDueDate;
        let projectApprovalWorkflowStepUsers: User[] = [];
        if (documentWorkflowStep) {
          projectApprovalWorkflowStepUsers = mapExistingUserInWorkflowStep(
            documentWorkflowStep.projectApprovalWorkflowSteps,
            users
          );
        }
        return {
          ...workflowStep,
          isRequired: documentWorkflowStep ? true : false,
          dueDate: documentWorkflowStep
            ? moment(documentDueDate).endOf('day').toDate()
            : null,
          users: projectApprovalWorkflowStepUsers
        };
      });
      setDocumentWorkflow({
        ...documentWorkflow,
        name: newValue.name,
        isCreatorViewOnlyExternal: newValue.isCreatorViewOnlyExternal,
        isCreatorViewOnlyFinal: newValue.isCreatorViewOnlyFinal,
        projectDocumentWorkflowSteps
      });
    } else {
      setDocumentWorkflow({
        ...documentWorkflow,
        name: '',
        isCreatorViewOnlyExternal: false,
        isCreatorViewOnlyFinal: false,
        projectDocumentWorkflowSteps: defaultWorkflowSteps
      });
    }
  }

  function getRelatedUser(workflowStepId: number): User[] {
    const userIds =
      workflowStepUsers.find(
        (workflowStepUser) => workflowStepUser.workflowStepId === workflowStepId
      )?.userIds ?? [];
    return !isShowAllUsers
      ? users.filter((user) => userIds.some((userId) => userId === user.id))
      : users;
  }

  function handleAnchorElement(
    open: boolean
  ): (event: React.MouseEvent<HTMLButtonElement>) => void {
    return function (event: React.MouseEvent<HTMLButtonElement>) {
      setAnchorElement(open ? event.currentTarget : null);
    };
  }

  function handleChangeRelatedUsers(): void {
    setIsShowAllUsers((prev) => !prev);
  }

  function handleEditWorkflow(edit: boolean): () => void {
    return function (): void {
      if (edit) {
        setIsPreviewWorkflow(false);
        setTempWorkflowStep(documentWorkflow.projectDocumentWorkflowSteps);
      } else {
        setIsPreviewWorkflow(true);
        setDocumentWorkflow({
          ...documentWorkflow,
          projectDocumentWorkflowSteps: tempWorkflowStep
        });
        setShowDueDateWarning(false);
      }
      scrollTo('reviewer-box');
    };
  }

  function viewWorkflowDetails(open: boolean) {
    return function () {
      setOpenWorkflowDialog(open);
      setTimeout(
        () => {
          setViewSkipStandardWorkflow(false);
        },
        open ? 0 : 300
      );
    };
  }

  function skipStandardWorkflow(skip: boolean) {
    return function () {
      setViewSkipStandardWorkflow(skip);
    };
  }

  function handleSelectProjectWorkflowTemplate() {
    viewWorkflowDetails(false)();
    setIsSkipStandardWorkflow(true);
    scrollTo('workflow-detail-box');
  }

  function handleClickBotChat(skip: boolean) {
    return function () {
      if (skip) {
        setOpenWorkflowDialog(true);
        setViewSkipStandardWorkflow(true);
      } else {
        setIsSkipStandardWorkflow(false);
        setTemplateFlows({ discipline: null, projectFlow: null });
      }
    };
  }

  function scrollTo(element: string, offset: number = 0): void {
    const scrollToMe = document.getElementById(element);
    if (scrollToMe) {
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = scrollToMe.getBoundingClientRect().top;
      const offsetPosition = elementRect - bodyRect - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  async function onSubmit(
    event: React.FormEvent<HTMLFormElement>
  ): Promise<void> {
    event.preventDefault();
    try {
      setLoading(true);
      if (documentRevisionId && documentWorkflow.name) {
        const createProjectDocumentWorkflow: CreateProjectDocumentWorkflowWithChecklist =
        {
          projectDocumentRevisionId: documentRevisionId,
          name: documentWorkflow.name,
          linkName: documentWorkflow.linkName,
          linkUrl: documentWorkflow.linkUrl,
          isAutoApproval: documentWorkflow.isAutoApproval,
          isCreatorViewOnlyExternal:
            documentWorkflow.isCreatorViewOnlyExternal,
          isCreatorViewOnlyFinal: documentWorkflow.isCreatorViewOnlyFinal,
          projectDocumentWorkflowSteps:
            documentWorkflow.projectDocumentWorkflowSteps,
          isChecked: documentWorkflow.isChecked,
          checklistLinkUrl: documentWorkflow.checklistLinkUrl,
          files: documentWorkflow.files
        };
        await dispatch(
          createProjectDocumentWorkflowAsync(createProjectDocumentWorkflow)
        ).unwrap();
        dispatch(
          loadingSlice.actions.success({
            message: t('projectDocumentWorkflowCreate.messages.workflowCreatedSuccessfully') as string
          })
        );
        setTimeout(() => {
          history.push(`/document-revisions/${documentRevisionId}`);
        }, 1000);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  if (!documentRevisionId) {
    return <Redirect to="/projects" />;
  }

  return (
    <div className={classes.root}>
      <Breadcrumb
        name="createDocumentWorkflow"
        data={{
          projectName: selectedProject?.name,
          projectId: selectedProject?.id,
          documentName: selectedProjectDocument?.name,
          documentId: selectedProjectDocument?.id,
          revisionName: `${t('projectDocumentWorkflowCreate.labels.purpose')}: ${selectedProjectDocumentRevision?.purpose.abbreviation}, ${t('projectDocumentWorkflowCreate.labels.revision')}: ${selectedProjectDocumentRevision?.revision.name}`,
          revisionId: selectedProjectDocumentRevision?.id
        }}
      />
      <Typography className={classes.title} component="p" variant="h4">
        {t('projectDocumentWorkflowCreate.title')}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} className={classes.showInformation}>
          {selectedProject && <ProjectInfoCard project={selectedProject} />}
          {selectedProjectDocument && selectedProjectDocumentRevision && (
            <DocRevisionInfoCard
              document={selectedProjectDocument}
              docRevision={selectedProjectDocumentRevision}
            />
          )}
        </Grid>
        <Grid item xs={12} md={9}>
          {isCompletedWorkflow && (
            <Alert className={classes.marginBottom1} severity="warning">
              {t('projectDocumentWorkflowCreate.alerts.cannotStartNewWorkflow')}
            </Alert>
          )}
          <form onSubmit={onSubmit}>
            {!refFlowId && isStandardWorkflowDocument && (
              <div className={classes.botArea}>
                <Avatar className={classes.botIcon}>
                  <BotIcon />
                </Avatar>
                <Paper className={classes.botChat} variant="outlined">
                  {!isSkipStandardWorkflow ? (
                    <>
                      <Typography variant="body1" gutterBottom>
                        {t('projectDocumentWorkflowCreate.botMessages.greeting')}
                      </Typography>
                      <Typography variant="body2">
                        {t('projectDocumentWorkflowCreate.botMessages.standardWorkflowNotice')}
                      </Typography>
                    </>
                  ) : (
                    <>
                      <Typography variant="body1" gutterBottom>
                        {t('projectDocumentWorkflowCreate.botMessages.apology')}
                      </Typography>
                      <Typography variant="body2">
                        {t('projectDocumentWorkflowCreate.botMessages.backToProjectMode.text1')} <b>{t('projectDocumentWorkflowCreate.botMessages.backToProjectMode.reset')}</b> {t('projectDocumentWorkflowCreate.botMessages.backToProjectMode.text2')}
                      </Typography>
                    </>
                  )}
                  <Button
                    className={classes.marginTop1}
                    variant="outlined"
                    size="small"
                    onClick={handleClickBotChat(!isSkipStandardWorkflow)}
                  >
                    {!isSkipStandardWorkflow
                      ? t('projectDocumentWorkflowCreate.buttons.dontWantGuideline')
                      : t('projectDocumentWorkflowCreate.buttons.reset')}
                  </Button>
                </Paper>
              </div>
            )}
            {!refFlowId && !isStandardWorkflow && (
              <Paper className={classes.card}>
                <div className={classes.flexAlignCenter}>
                  <Typography
                    className={classes.flexGrow}
                    variant="subtitle1"
                    gutterBottom
                  >
                    {t('projectDocumentWorkflowCreate.sections.projectWorkflow')}
                    <HelpTooltip>
                      {t('projectDocumentWorkflowCreate.helpTexts.workflowTemplate')}
                    </HelpTooltip>
                  </Typography>
                  <Button
                    component={RRLink}
                    to={`/project-workflows/create?projectId=${selectedProject?.id
                      }&redirect=/document-workflows/create?documentRevisionId=${documentRevisionId}${templateFlows.projectFlow
                        ? '&refFlowId=' + templateFlows.projectFlow.id
                        : ''
                      }`}
                    variant="outlined"
                    color="primary"
                    size="small"
                    startIcon={
                      templateFlows.projectFlow ? (
                        <FileCopyOutlined />
                      ) : (
                        <AddRounded />
                      )
                    }
                  >
                    {templateFlows.projectFlow
                      ? t('projectDocumentWorkflowCreate.buttons.copyTemplate')
                      : t('projectDocumentWorkflowCreate.buttons.createTemplate')}
                  </Button>
                </div>
                <Divider className={classes.divider} />
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <Autocomplete
                      className={classes.fullWidth}
                      id="discipline"
                      options={disciplines}
                      getOptionLabel={(option) => option?.name}
                      value={templateFlows.discipline}
                      getOptionSelected={(option, value) =>
                        option.id === value?.id
                      }
                      onChange={(event, newValue) => {
                        setTemplateFlows({
                          ...templateFlows,
                          discipline: newValue,
                          projectFlow: null
                        });
                        setDocumentWorkflow({
                          ...documentWorkflow,
                          projectDocumentWorkflowSteps: defaultWorkflowSteps
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          size="small"
                          label={t('projectDocumentWorkflowCreate.labels.discipline')}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Autocomplete
                      className={classes.fullWidth}
                      id="project-flow-name"
                      options={projectWorkflows.filter((projectWorkflow) =>
                        templateFlows.discipline
                          ? projectWorkflow.disciplineId ===
                          templateFlows.discipline.id
                          : true
                      )}
                      getOptionLabel={(option) => option?.name}
                      value={templateFlows.projectFlow}
                      getOptionSelected={(option, value) =>
                        option.id === value?.id
                      }
                      onChange={onChangeWorkflowTemplate}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          size="small"
                          label={t('projectDocumentWorkflowCreate.labels.projectWorkflow')}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Paper>
            )}
            <Paper className={classes.card} id="workflow-detail-box">
              <Typography
                className={classes.flexGrow}
                variant="subtitle1"
                gutterBottom
              >
                {t('projectDocumentWorkflowCreate.sections.workflowDetails')}
              </Typography>
              <Divider className={classes.divider} />
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    className={classes.fullWidth}
                    id="document-flow-name"
                    label={t('projectDocumentWorkflowCreate.labels.documentWorkflowName')}
                    variant="outlined"
                    size="small"
                    value={documentWorkflow.name}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setDocumentWorkflow({
                        ...documentWorkflow,
                        name: event.target.value
                      });
                    }}
                    required
                  />
                </Grid>
                {SHOW_LINK_DUE_DATE && (
                  <>
                    <Grid item xs={12}>
                      <Alert
                        severity="warning"
                        icon={<LinkRounded className={classes.rotate45} />}
                      >
                        {t('projectDocumentWorkflowCreate.alerts.urlFieldRemoval.text1')}{' '}
                        <b>{moment(WORKFLOW_LINK_DUE_DATE).format('ll')}</b>,
                        {t('projectDocumentWorkflowCreate.alerts.urlFieldRemoval.text2')}
                      </Alert>
                    </Grid>
                    <Grid item xs={12} sm={documentWorkflow.linkUrl ? 8 : 12}>
                      <TextField
                        className={classes.fullWidth}
                        id="link-url"
                        label={t('projectDocumentWorkflowCreate.labels.websiteUrl')}
                        variant="outlined"
                        size="small"
                        type="url"
                        value={
                          documentWorkflow.linkUrl
                            ? documentWorkflow.linkUrl
                            : ''
                        }
                        onChange={(event) => {
                          const linkUrl = event.target.value;
                          setDocumentWorkflow({
                            ...documentWorkflow,
                            linkUrl: linkUrl === '' ? null : linkUrl,
                            linkName:
                              linkUrl === '' ? null : documentWorkflow.linkName
                          });
                        }}
                        required={Boolean(documentWorkflow.linkName)}
                      />
                    </Grid>
                    {documentWorkflow.linkUrl && (
                      <Grid item xs={12} sm={4}>
                        <TextField
                          className={classes.fullWidth}
                          id="link-name"
                          label={t('projectDocumentWorkflowCreate.labels.linkName')}
                          variant="outlined"
                          size="small"
                          value={
                            documentWorkflow.linkName
                              ? documentWorkflow.linkName
                              : ''
                          }
                          onChange={(event) => {
                            setDocumentWorkflow({
                              ...documentWorkflow,
                              linkName:
                                event.target.value === ''
                                  ? null
                                  : event.target.value
                            });
                          }}
                        />
                      </Grid>
                    )}
                    {documentWorkflow.linkUrl && (
                      <Grid className={classes.linkBox} item xs={12}>
                        <Typography
                          className={clsx(classes.link, classes.marginLR)}
                          component="a"
                          href={checkWebUrl(documentWorkflow.linkUrl)}
                          target="_blank"
                          variant="body1"
                          display="inline"
                        >
                          {documentWorkflow.linkName
                            ? documentWorkflow.linkName
                            : documentWorkflow.linkUrl}
                          <LaunchRounded color="action" fontSize="small" />
                        </Typography>
                      </Grid>
                    )}
                  </>
                )}
              </Grid>
            </Paper>
            <Paper className={classes.card} id="reviewer-box">
              <div className={classes.flexAlignCenter}>
                <Typography
                  className={classes.flexGrow}
                  variant="subtitle1"
                  gutterBottom
                >
                  {t('projectDocumentWorkflowCreate.sections.documentWorkflow')}
                </Typography>
                {isStandardWorkflow && !isPreviewWorkflow && (
                  <>
                    <Badge
                      color="secondary"
                      variant="dot"
                      overlap="circle"
                      invisible={Boolean(anchorElement) || !isShowAllUsers}
                    >
                      <IconButton
                        size="small"
                        onClick={handleAnchorElement(true)}
                      >
                        <MoreVertRounded />
                      </IconButton>
                    </Badge>
                    <Menu
                      anchorEl={anchorElement}
                      keepMounted
                      getContentAnchorEl={null}
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                      }}
                      open={Boolean(anchorElement)}
                      onClose={handleAnchorElement(false)}
                    >
                      <FormControlLabel
                        className={classes.marginFormControlLabel}
                        control={
                          <Checkbox
                            checked={isShowAllUsers}
                            onChange={handleChangeRelatedUsers}
                          />
                        }
                        label={t('projectDocumentWorkflowCreate.labels.showAllUsers')}
                      />
                    </Menu>
                  </>
                )}
              </div>
              <Divider className={classes.divider} />
              {!isPreviewWorkflow ? (
                <>
                  <Alert severity="info">
                    {t('projectDocumentWorkflowCreate.alerts.workflowStepsInfo.text1')}
                    <span className={classes.colorRed}> ※</span>, {t('projectDocumentWorkflowCreate.alerts.workflowStepsInfo.text2')}
                  </Alert>
                  {documentWorkflow.projectDocumentWorkflowSteps.map(
                    (documentWorkflowStep, index) => {
                      const selectOneUser = selectOnlyOneUser(
                        documentWorkflowStep.id
                      );
                      return (
                        <div key={documentWorkflowStep.id}>
                          <div className={classes.flexFlowStep}>
                            <Avatar
                              className={clsx(classes.smallAvatar, {
                                [classes.avatarDisabled]:
                                  !documentWorkflowStep.isRequired
                              })}
                            >
                              {index + 1}
                            </Avatar>
                            <Typography
                              className={clsx(
                                classes.flexGrowName,
                                classes.lineHeight120
                              )}
                              variant="subtitle1"
                              color={
                                documentWorkflowStep.isRequired
                                  ? 'textPrimary'
                                  : 'textSecondary'
                              }
                            >
                              {documentWorkflowStep.name}
                              {!documentWorkflowStep.canStopWorkflow &&
                                documentWorkflowStep.isRequired && (
                                  <span className={classes.colorRed}> ※</span>
                                )}
                            </Typography>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={documentWorkflowStep?.isRequired}
                                  onChange={(event) => {
                                    onChangeByField(
                                      documentWorkflowStep.id,
                                      event.target.checked,
                                      'isRequired'
                                    );
                                    setShowDueDateWarning(true);
                                  }}
                                  name={`${documentWorkflowStep.id}`}
                                  color="primary"
                                />
                              }
                              label={t('projectDocumentWorkflowCreate.labels.required')}
                            />
                          </div>
                          <Collapse in={documentWorkflowStep.isRequired}>
                            <Autocomplete
                              className={classes.userField}
                              id={`userId-${documentWorkflowStep.id}`}
                              size="small"
                              multiple
                              loading={usersLoading}
                              options={getRelatedUser(documentWorkflowStep.id)}
                              getOptionLabel={(option) =>
                                `${option?.firstName} ${option?.lastName}`
                              }
                              renderTags={(tagValue, getTagProps) =>
                                tagValue.map((option, index) => (
                                  <Chip
                                    label={`${option?.firstName} ${option?.lastName}`}
                                    {...getTagProps({ index })}
                                    variant="outlined"
                                    size="small"
                                    deleteIcon={<ClearRounded />}
                                  />
                                ))
                              }
                              value={documentWorkflowStep.users}
                              getOptionSelected={(option, value) =>
                                option.id === value?.id
                              }
                              onChange={(event, newValue) =>
                                onChangeByField(
                                  documentWorkflowStep.id,
                                  newValue,
                                  'users',
                                  { selectOneUser }
                                )
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  placeholder={
                                    usersLoading
                                      ? 'Loading users...'
                                      : documentWorkflowStep.users.length === 0
                                      ? getRelatedUser(documentWorkflowStep.id)
                                        .length === 0
                                        ? (t('projectDocumentWorkflowCreate.placeholders.contactProjectManager') as string)
                                        : (t('projectDocumentWorkflowCreate.placeholders.selectUser') as string)
                                      : ''
                                  }
                                  required={
                                    documentWorkflowStep.isRequired &&
                                    documentWorkflowStep.users.length === 0
                                  }
                                  error={
                                    selectOneUser &&
                                    documentWorkflowStep.isRequired &&
                                    documentWorkflowStep.users.length > 1
                                  }
                                  helperText={
                                    selectOneUser &&
                                    documentWorkflowStep.isRequired &&
                                    (t('projectDocumentWorkflowCreate.messages.selectOnlyOnePerson') as string)
                                  }
                                />
                              )}
                            />
                            <div className={classes.dueDateField}>
                              <Typography
                                className={clsx(
                                  classes.flexGrowName,
                                  classes.lineHeight120
                                )}
                                variant="body2"
                                align="right"
                              >
                                {t('projectDocumentWorkflowCreate.labels.dueDate')}
                              </Typography>
                              <KeyboardDatePicker
                                autoOk
                                size="small"
                                variant="inline"
                                inputVariant="outlined"
                                InputAdornmentProps={{ position: 'end' }}
                                id={`due-date-${documentWorkflowStep.id}`}
                                value={documentWorkflowStep.dueDate}
                                onChange={(date) =>
                                  onChangeByField(
                                    documentWorkflowStep.id,
                                    date,
                                    'dueDate'
                                  )
                                }
                                KeyboardButtonProps={{
                                  'aria-label': 'change date'
                                }}
                                disablePast
                                required={documentWorkflowStep.isRequired}
                              />
                            </div>
                          </Collapse>
                        </div>
                      );
                    }
                  )}
                  {notFoundUserPosition && (
                    <Alert
                      className={classes.marginTop2}
                      severity="warning"
                      action={
                        <Button
                          color="inherit"
                          size="small"
                          onClick={onResetAllSteps}
                        >
                          {t('projectDocumentWorkflowCreate.buttons.reset')}
                        </Button>
                      }
                    >
                      {t('projectDocumentWorkflowCreate.alerts.addUserToStart.text1')} <b>{t('projectDocumentWorkflowCreate.alerts.addUserToStart.reset')}</b> {t('projectDocumentWorkflowCreate.alerts.addUserToStart.text2')}
                    </Alert>
                  )}
                  {!notFoundUserPosition && showDueDateWarning && (
                    <Alert className={classes.marginTop2} severity="warning">
                      {t('projectDocumentWorkflowCreate.alerts.dueDateWarning.text1')} <b>{t('projectDocumentWorkflowCreate.alerts.dueDateWarning.recalculate')}</b> {t('projectDocumentWorkflowCreate.alerts.dueDateWarning.text2')}
                    </Alert>
                  )}
                  <div
                    className={clsx(classes.actionButtonArea, {
                      [classes.marginTop2]:
                        (isStandardWorkflow && !isPreviewWorkflow) ||
                        !notFoundUserPosition
                    })}
                  >
                    {isStandardWorkflow && !isPreviewWorkflow && (
                      <Button fullWidth onClick={handleEditWorkflow(false)}>
                        {t('projectDocumentWorkflowCreate.buttons.cancel')}
                      </Button>
                    )}
                    {!notFoundUserPosition && (
                      <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        startIcon={<UpdateRounded />}
                        onClick={onReCalculateDueDate}
                      >
                        {t('projectDocumentWorkflowCreate.buttons.recalculate')}
                      </Button>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <Alert
                    severity="info"
                    icon={<AutoAwesomeRounded fontSize="inherit" />}
                    action={
                      <Button
                        className={classes.lineHeight120}
                        color="inherit"
                        size="small"
                        onClick={viewWorkflowDetails(true)}
                      >
                        {t('projectDocumentWorkflowCreate.buttons.viewGuideline')}
                      </Button>
                    }
                  >
                    {t('projectDocumentWorkflowCreate.alerts.membersAutoAssigned')}
                  </Alert>
                  {!notFoundUserPosition ? (
                    documentWorkflow.projectDocumentWorkflowSteps.map(
                      (documentWorkflowStep, index) => {
                        return (
                          <div key={documentWorkflowStep.id}>
                            {documentWorkflowStep.isRequired && (
                              <>
                                <div className={classes.flexFlowStep}>
                                  <Avatar className={classes.smallAvatar}>
                                    {index + 1}
                                  </Avatar>
                                  <div className={classes.flexGrowName}>
                                    <Typography
                                      className={classes.lineHeight120}
                                      variant="subtitle1"
                                      color="textPrimary"
                                    >
                                      {documentWorkflowStep.name}
                                    </Typography>
                                    {selectOnlyOneUser(
                                      documentWorkflowStep.id
                                    ) &&
                                      documentWorkflowStep.users.length > 1 && (
                                        <Typography
                                          className={classes.lineHeight120}
                                          display="block"
                                          variant="caption"
                                          color="error"
                                        >
                                          * {t('projectDocumentWorkflowCreate.messages.requiredOnlyOnePerson')}
                                        </Typography>
                                      )}
                                  </div>
                                  <Typography
                                    className={classes.lineHeight120}
                                    variant="caption"
                                    align="right"
                                  >
                                    <b>{t('projectDocumentWorkflowCreate.labels.dueDate')} :</b>
                                    <br />
                                    {moment(
                                      documentWorkflowStep.dueDate
                                    ).format('ll')}
                                  </Typography>
                                </div>
                                <div className={classes.chipField}>
                                  {documentWorkflowStep.users.length > 0 ? (
                                    documentWorkflowStep.users.map(
                                      (user, index) => (
                                        <Chip
                                          key={index}
                                          className={classes.truncatedChip}
                                          label={`${user.firstName} ${user.lastName}`}
                                          variant="outlined"
                                          size="small"
                                        />
                                      )
                                    )
                                  ) : (
                                    <Typography
                                      variant="caption"
                                      color="textSecondary"
                                    >
                                      <i>{t('projectDocumentWorkflowCreate.messages.userNotFound')}</i>
                                    </Typography>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        );
                      }
                    )
                  ) : (
                    <div className={classes.userNotFoundError}>
                      <Typography gutterBottom>{t('projectDocumentWorkflowCreate.messages.oops')}</Typography>
                      <Typography component="div" variant="caption">
                        {t('projectDocumentWorkflowCreate.messages.systemCouldntAssign')}
                      </Typography>
                      <Typography component="div" variant="caption">
                        {t('projectDocumentWorkflowCreate.messages.contactProjectManager')}
                      </Typography>
                    </div>
                  )}
                  {isStandardWorkflow && isPreviewWorkflow && (
                    <Button
                      className={classes.marginTop2}
                      variant="outlined"
                      color="primary"
                      fullWidth
                      startIcon={<EditRounded />}
                      onClick={handleEditWorkflow(true)}
                    >
                      {t('projectDocumentWorkflowCreate.buttons.editWorkflow')}
                    </Button>
                  )}
                </>
              )}
            </Paper>
            <Paper className={classes.checklistCard}>
              <div className={classes.padding2}>
                <div className={classes.flexAlignCenter}>
                  <Typography className={classes.flexGrow} variant="subtitle1">
                    {t('projectDocumentWorkflowCreate.sections.qualityCheck')}
                  </Typography>
                  <input
                    key={inputKey}
                    {...getInputProps()}
                    id="upload-checklist-file"
                    disabled={loading}
                  />
                  <label htmlFor="upload-checklist-file">
                    <Button
                      component="span"
                      variant="contained"
                      color="primary"
                      size="small"
                      startIcon={<CloudUploadRounded />}
                    >
                      {t('projectDocumentWorkflowCreate.buttons.uploadChecklist')}
                    </Button>
                  </label>
                </div>
                <div className={classes.flexDivider}>
                  <Divider className={classes.divider} />
                  <Typography
                    className={classes.marginLR}
                    variant="caption"
                    color="textSecondary"
                  >
                    {t('projectDocumentWorkflowCreate.labels.maximumSize')}: {MAX_SIZE_IN_MB} MB/{t('projectDocumentWorkflowCreate.labels.file')}
                  </Typography>
                </div>
                <div className={classes.checklistFile}>
                  {documentWorkflow.files.length === 0 && (
                    <div className={classes.notFoundChecklistFile}>
                      <Typography>{t('projectDocumentWorkflowCreate.messages.dropFilesHere')}</Typography>
                      <Typography color="textSecondary" variant="caption">
                        {t('projectDocumentWorkflowCreate.messages.orUseThe')} <b>{t('projectDocumentWorkflowCreate.buttons.uploadChecklist').toUpperCase()}</b> {t('projectDocumentWorkflowCreate.messages.button')}
                      </Typography>
                    </div>
                  )}
                  {fileList(documentWorkflow.files)}
                </div>
                <div className={classes.marginTop1}>
                  <OutlinedInput
                    id="link-url"
                    style={{ height: 40 }}
                    placeholder={t('projectDocumentWorkflowCreate.placeholders.websiteUrl') as string}
                    type="url"
                    value={
                      documentWorkflow.checklistLinkUrl
                        ? documentWorkflow.checklistLinkUrl
                        : ''
                    }
                    onChange={(event) =>
                      setDocumentWorkflow({
                        ...documentWorkflow,
                        checklistLinkUrl:
                          event.target.value === '' ? null : event.target.value
                      })
                    }
                    endAdornment={
                      documentWorkflow.checklistLinkUrl && (
                        <InputAdornment position="end">
                          <Tooltip title={t('projectDocumentWorkflowCreate.tooltips.preview') as string} arrow>
                            <IconButton
                              onClick={() => {
                                if (documentWorkflow.checklistLinkUrl)
                                  window.open(
                                    documentWorkflow.checklistLinkUrl,
                                    '_blank'
                                  );
                              }}
                              edge="end"
                            >
                              <LaunchRounded />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      )
                    }
                    fullWidth
                  />
                </div>
                <FormControl
                  component="fieldset"
                  error={!documentWorkflow.isChecked}
                  required
                >
                  <FormControlLabel
                    className={classes.marginTop2}
                    control={
                      <Checkbox
                        color="primary"
                        checked={documentWorkflow.isChecked}
                        onChange={(event) =>
                          setDocumentWorkflow({
                            ...documentWorkflow,
                            isChecked: event.target.checked
                          })
                        }
                      />
                    }
                    label={
                      <span>
                        {t('projectDocumentWorkflowCreate.labels.selfCheckConfirmation')}
                        <span className={classes.colorRed}> *</span>
                      </span>
                    }
                  />
                  {!documentWorkflow.isChecked && (
                    <FormHelperText className={classes.formHelperText}>
                      * {t('projectDocumentWorkflowCreate.messages.pleaseCheckCheckbox')}
                    </FormHelperText>
                  )}
                </FormControl>
              </div>
              <DropzoneArea
                dropzoneArea={dropzoneArea}
                getRootProps={getRootProps}
                getInputProps={getInputProps}
                maxFileSizeInMB={MAX_SIZE_IN_MB}
                inputKey={inputKey}
                inDropzone={inDropzone}
                disabled={loading}
              />
            </Paper>
            {/* This section will use for changing auto approval workflow individually, it is hided because don't need user change it manually */}
            {false && (
              <Paper className={classes.card}>
                <FormControlLabel
                  className={classes.marginRightNone}
                  control={
                    <Checkbox
                      disabled={
                        selectedProjectDocumentRevision?.purpose?.id !==
                        PurposeLabel.IFR
                      }
                      checked={documentWorkflow.isAutoApproval}
                      onChange={(event) =>
                        setDocumentWorkflow({
                          ...documentWorkflow,
                          isAutoApproval: event.target.checked
                        })
                      }
                    />
                  }
                  label={
                    <span>
                      <i>({t('projectDocumentWorkflowCreate.labels.optional')})</i> {t('projectDocumentWorkflowCreate.labels.autoApprovalConfig')}
                    </span>
                  }
                />
                {selectedProjectDocumentRevision?.purpose?.id !==
                  PurposeLabel.IFR && (
                    <HelpTooltip>
                      {t('projectDocumentWorkflowCreate.helpTexts.onlyIfrPurpose')}
                    </HelpTooltip>
                  )}
              </Paper>
            )}
            {documentWorkflow.isAutoApproval && (
              <Alert className={classes.marginBottom2} severity="info">
                {t('projectDocumentWorkflowCreate.alerts.autoApproved.text1')} <b>{t('projectDocumentWorkflowCreate.alerts.autoApproved.autoApproved')}</b>
              </Alert>
            )}
            {!isCompletedWorkflow && (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                disabled={
                  !documentWorkflow.isChecked ||
                  showDueDateWarning ||
                  notFoundUserPosition ||
                  moreThanOneUserInWorkflowStep ||
                  loading
                }
                startIcon={<LocalShippingRounded />}
              >
                {!loading ? t('projectDocumentWorkflowCreate.buttons.startWorkflow') : t('projectDocumentWorkflowCreate.buttons.loading')}
              </Button>
            )}
          </form>
        </Grid>
      </Grid>
      {documentWithProjectUsers && (
        <Dialog
          fullWidth
          open={openWorkflowDialog}
          onClose={viewWorkflowDetails(false)}
        >
          <DialogTitle className={classes.dialogTitle}>
            <div className={classes.flexAlignCenter}>
              <Typography className={classes.flexGrow} variant="h6" noWrap>
                {t('projectDocumentWorkflowCreate.dialogs.guidelineStandardWorkflow')}
              </Typography>
              <Tooltip title={t('projectDocumentWorkflowCreate.tooltips.close') as string} arrow>
                <IconButton
                  size="small"
                  edge="end"
                  onClick={viewWorkflowDetails(false)}
                >
                  <ClearRounded />
                </IconButton>
              </Tooltip>
            </div>
          </DialogTitle>
          {!viewSkipStandardWorkflow && (
            <DialogContent className={classes.dialogContent}>
              <Alert severity="info">
                <b>{documentWithProjectUsers.name}</b> {t('projectDocumentWorkflowCreate.dialogs.hasPositionsFollowing')}
              </Alert>
              {headers.map((workflowStep) => {
                const projectPositionWorkflowSteps =
                  workflowStep.projectPositionWorkflowSteps.filter(({ id }) =>
                    documentWithProjectUsers.projectPositionWorkflowSteps.some(
                      (projectPositionWorkflowStep) =>
                        projectPositionWorkflowStep.id === id
                    )
                  );
                if (projectPositionWorkflowSteps.length > 0) {
                  return (
                    <Paper variant="outlined" key={workflowStep.id}>
                      <div
                        className={clsx(classes.flexAlignCenter, classes.gap)}
                      >
                        <FaceRounded color="primary" fontSize="small" />
                        <Typography noWrap>{workflowStep.name}</Typography>
                      </div>
                      <Typography
                        className={classes.lineHeight120}
                        display="block"
                        variant="caption"
                        gutterBottom
                      >
                        {projectPositionWorkflowSteps
                          .map(({ projectPosition }) => {
                            return projectPosition.name;
                          })
                          .join(' • ')}
                      </Typography>
                    </Paper>
                  );
                }
              })}
            </DialogContent>
          )}
          {viewSkipStandardWorkflow && (
            <DialogContent className={classes.dialogContentSkipWorkflow}>
              <div className={classes.dialogAreaSkipWorkflow}>
                <Typography gutterBottom>
                  {t('projectDocumentWorkflowCreate.dialogs.standardWorkflowHelp')}
                </Typography>
                <Typography>
                  ● {t('projectDocumentWorkflowCreate.dialogs.instructions.usersNotAssigned')}{' '}
                  <b>{t('projectDocumentWorkflowCreate.dialogs.instructions.projectManager')}</b> {t('projectDocumentWorkflowCreate.dialogs.instructions.addPosition')}
                  <br />● {t('projectDocumentWorkflowCreate.dialogs.instructions.cannotFindTemplate')}
                  <b>{t('projectDocumentWorkflowCreate.dialogs.instructions.backspaceSupport')}</b> {t('projectDocumentWorkflowCreate.dialogs.instructions.addNewOne')}
                </Typography>
                <Divider />
                <Typography>
                  {t('projectDocumentWorkflowCreate.dialogs.doYouStillWant')}
                </Typography>
              </div>
            </DialogContent>
          )}
          <div className={classes.dialogAction}>
            {!viewSkipStandardWorkflow && (
              <Button
                variant="outlined"
                onClick={skipStandardWorkflow(true)}
                endIcon={<KeyboardArrowRightRounded />}
                fullWidth
              >
                {t('projectDocumentWorkflowCreate.buttons.dontWantGuideline')}
              </Button>
            )}
            {viewSkipStandardWorkflow && (
              <>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={viewWorkflowDetails(false)}
                  fullWidth
                >
                  {t('projectDocumentWorkflowCreate.buttons.noUseGuideline')}
                </Button>
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={handleSelectProjectWorkflowTemplate}
                  fullWidth
                >
                  {t('projectDocumentWorkflowCreate.buttons.yesIWant')}
                </Button>
              </>
            )}
          </div>
        </Dialog>
      )}
    </div>
  );
}

function NotFoundPositionUser() {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { selectedProjectDocument } = useSelector(
    (state: RootState) => state.projectDocuments
  );
  const { selectedProject } = useSelector((state: RootState) => state.projects);

  const [disabledReload, setDisabledReload] = useState<boolean>(false);

  async function reloadUserPosition(): Promise<void> {
    try {
      setDisabledReload(true);
      if (selectedProject && selectedProjectDocument && selectedProject.id) {
        await dispatch(
          reloadUserProjectPositionsAsync({ projectId: selectedProject.id })
        ).unwrap();
        dispatch(
          getDocumentWithProjectUsersAsync({
            id: selectedProjectDocument.documentId,
            projectId: selectedProject.id
          })
        );
      }
    } catch { }
  }

  return (
    <>
      <Typography gutterBottom>{t('projectDocumentWorkflowCreate.notFoundPosition.somethingWrong')}</Typography>
      <Typography component="div" variant="caption">
        {t('projectDocumentWorkflowCreate.notFoundPosition.cannotFindUsers')}
      </Typography>
      <Button
        variant="outlined"
        color="primary"
        size="small"
        disabled={disabledReload}
        startIcon={<SyncRounded />}
        onClick={reloadUserPosition}
      >
        {!disabledReload ? t('projectDocumentWorkflowCreate.buttons.reload') : t('projectDocumentWorkflowCreate.buttons.reloaded')}
      </Button>
      <Divider className={classes.dividerCenter} />
      <Typography component="div" variant="caption">
        {t('projectDocumentWorkflowCreate.notFoundPosition.ifNotWorking')}
      </Typography>
    </>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(1.5, 0, 12, 0)
    },
    title: {
      margin: theme.spacing(1.5, 0, 2, 0),
      [theme.breakpoints.down('xs')]: {
        textAlign: 'center',
        margin: theme.spacing(3.5, 0, 4, 0)
      }
    },
    card: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      borderRadius: theme.spacing(2)
    },
    divider: {
      margin: theme.spacing(0.5, 0, 2, 0),
      width: theme.spacing(4)
    },
    checklistCard: {
      marginBottom: theme.spacing(2),
      borderRadius: theme.spacing(2),
      position: 'relative'
    },
    checklistFile: { minHeight: 64 },
    notFoundChecklistFile: {
      padding: theme.spacing(1, 2),
      textAlign: 'center'
    },
    formHelperText: {
      marginLeft: theme.spacing(4)
    },
    fullWidth: {
      width: '100%'
    },
    smallAvatar: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      backgroundColor: theme.palette.primary.main
    },
    avatarDisabled: {
      backgroundColor: theme.palette.text.disabled
    },
    dialogTitle: {
      padding: theme.spacing(2, 2, 1, 2.5)
    },
    dialogContent: {
      padding: theme.spacing(0, 2, 2, 2),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
      '& > *:not(:first-child)': {
        padding: theme.spacing(0.5, 1),
        borderRadius: theme.spacing(1)
      }
    },
    dialogContentSkipWorkflow: {
      padding: theme.spacing(0, 2, 2, 2)
    },
    dialogAreaSkipWorkflow: {
      padding: theme.spacing(1),
      '& > *': {
        '&.MuiDivider-root': { margin: theme.spacing(2, 0) }
      }
    },
    dialogAction: {
      display: 'flex',
      padding: theme.spacing(0, 2, 2, 2),
      gap: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column-reverse'
      }
    },
    flexFlowStep: {
      display: 'flex',
      alignItems: 'center',
      margin: theme.spacing(2, 0, 1, 0)
    },
    flexGrowName: {
      flexGrow: 1,
      padding: theme.spacing(0, 2)
    },
    marginTop1: {
      marginTop: theme.spacing(1)
    },
    marginTop2: {
      marginTop: theme.spacing(2)
    },
    marginBottom1: {
      marginBottom: theme.spacing(1)
    },
    marginBottom2: {
      marginBottom: theme.spacing(2)
    },
    marginLR: {
      margin: theme.spacing(0, 1)
    },
    padding2: {
      padding: theme.spacing(2)
    },
    flexGrow: {
      flexGrow: 1
    },
    flexAlignCenter: {
      display: 'flex',
      alignItems: 'center'
    },
    gap: {
      gap: theme.spacing(0.5)
    },
    flexDivider: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    filename: {
      wordBreak: 'break-word'
    },
    userField: {
      width: `calc(100% - ${theme.spacing(8)}px)`,
      marginLeft: theme.spacing(6)
    },
    dueDateField: {
      display: 'flex',
      alignItems: 'center',
      width: `calc(100% - ${theme.spacing(8)}px)`,
      marginLeft: theme.spacing(6),
      marginTop: theme.spacing(1.5),
      '& .MuiOutlinedInput-adornedEnd': {
        paddingRight: 0
      }
    },
    lineHeight120: {
      lineHeight: '120%'
    },
    chipField: {
      width: `calc(100% - ${theme.spacing(6)}px)`,
      marginLeft: theme.spacing(6),
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(0.5)
    },
    truncatedChip: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%' // Adjust this to control the maximum width of the Chip
    },
    userNotFoundError: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      padding: theme.spacing(4, 2)
    },
    dividerCenter: {
      margin: theme.spacing(2, 0, 1, 0),
      width: theme.spacing(4)
    },
    marginFormControlLabel: {
      margin: theme.spacing(0, 1.5, 0, 0)
    },
    marginRightNone: {
      marginRight: 0
    },
    actionButtonArea: {
      display: 'flex',
      gap: theme.spacing(1),
      flexDirection: 'row',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column-reverse'
      }
    },
    showInformation: {
      [theme.breakpoints.down('sm')]: {
        display: 'none'
      }
    },
    rotate45: {
      rotate: '-45deg'
    },
    link: {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
      cursor: 'pointer',
      '&:hover': {
        color: theme.palette.primary.dark
      },
      wordBreak: 'break-all'
    },
    linkBox: {
      borderRadius: theme.spacing(1),
      borderColor: '#dddddd',
      backgroundColor: fade(theme.palette.background.default, 0.75),
      margin: theme.spacing(0.8, 1)
    },
    botArea: {
      display: 'flex',
      gap: theme.spacing(0.5),
      marginBottom: theme.spacing(2)
    },
    botIcon: {
      width: '32px',
      height: '32px',
      borderStyle: 'solid',
      borderWidth: 'thin',
      color: theme.palette.primary.contrastText,
      borderColor: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main
    },
    botChat: {
      flexGrow: 1,
      padding: theme.spacing(1, 1.5, 1.5, 1.5),
      borderRadius: theme.spacing(0.5, 3, 3, 3)
    },
    colorRed: {
      color: theme.palette.error.main
    }
  })
);
